import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {
    AiSetupAcceptRequest,
    AiSetupJobDetail,
    AiSetupJobInfo,
    AiSetupRequest,
    FundApiService
} from "../../fund/generated-sources/api";

@Injectable({providedIn: "root"})
export class FundAiSetupService {

    private readonly fundApi = inject(FundApiService);

    start(fundId: number, request: AiSetupRequest): Observable<number> {
        return this.fundApi.startAiSetup(fundId, request);
    }

    getJobsForFund(fundId: number): Observable<AiSetupJobInfo[]> {
        return this.fundApi.getAiSetupJobsForFund(fundId);
    }

    getJobDetail(taskInfoId: number): Observable<AiSetupJobDetail> {
        return this.fundApi.getAiSetupJobDetail(taskInfoId);
    }

    acceptResult(resultId: number, request: AiSetupAcceptRequest): Observable<unknown> {
        return this.fundApi.acceptAiSetupResult(resultId, request);
    }

    skipResult(resultId: number): Observable<unknown> {
        return this.fundApi.skipAiSetupResult(resultId);
    }
}
